import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@stashinvest/ui';
import { useCachedGet, setDedupingIntervals } from '@stashinvest/use-fetch';

const manifestPath = '/apis/api/v1/manifest';

const hourInMs = 1000 * 60 * 60;

setDedupingIntervals({
  [manifestPath]: hourInMs * 2,
});

function getTipText({ glossary, item }) {
  const noItemFound = 'Sorry, this information is not available at the moment';
  if (item && glossary) {
    return glossary.find((gItem) => gItem.key === item)?.definition || noItemFound;
  }
  return noItemFound;
}

const GlossaryTooltip = ({ item, ...rest }) => {
  const { data } = useCachedGet({
    path: manifestPath,
    onMount: true,
  });
  return (
    <Tooltip
      {...rest}
      label={getTipText({
        item,
        glossary: data?.glossary,
      })}
    />
  );
};

GlossaryTooltip.propTypes = {
  item: PropTypes.string,
};

export default GlossaryTooltip;
